// import {TweenMax} from "gsap/TweenMax";
import ScrollMagic from "scrollmagic";
// import 'imports-loader?define=>false!scrollmagic/scrollmagic/uncompressed/plugins/animation.gsap';
import 'imports-loader?define=>false!scrollmagic/scrollmagic/uncompressed/plugins/debug.addIndicators.js';


var controller = new ScrollMagic.Controller();

var scene_hero = new ScrollMagic.Scene({
  triggerElement: "body",
  triggerHook: 'onEnter',
  // duration: 800,
  offset: 0
})
  // .addIndicators()
  .addTo(controller);

scene_hero.on('enter', () => {
  //triggerElementを過ぎたとき
});
scene_hero.on('leave', () => {
  //triggerElementを抜けたとき
});


// var scene_top_logo = new ScrollMagic.Scene({
//   triggerElement: ".top-hero-logo__image",
//   triggerHook: 'onEnter',
//   // duration: 800,
//   offset: 0
// })
//   // .addIndicators()
//   .addTo(controller);

// scene_top_logo.on('enter', () => {
//   //triggerElementを過ぎたとき
//   $('.page-top').addClass('is-active');
// });
// scene_top_logo.on('leave', () => {
//   //triggerElementを抜けたとき
//   $('.page-top').removeClass('is-active');
// });

if ($('.top-hero-main-pop').length) {
  var scene_footer = new ScrollMagic.Scene({
    triggerElement: ".l-footer",
    triggerHook: 'onEnter',
    // duration: 300,
    offset: 0
  }).addTo(controller);

  scene_footer.on('enter', () => {
    $(".top-hero-main-pop").addClass("is-vanish");
  });
  scene_footer.on('leave', () => {
    $(".top-hero-main-pop").removeClass("is-vanish");
  });
}


